export default __webpack_public_path__ + "static/media/cctv.0cebfc5c.png";